(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-review-quotes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-quotes-slider')) {
    class ReviewQuotesSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.viewport = this.querySelector('.product-review-quotes__viewport');
        this.track = this.querySelector('.product-review-quotes__track');
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        this.realCount = this.slides.length;
        this.index = 0;
        this.dragOffset = 0;
        this.intervalMs = Number(this.dataset.interval) || 4000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.track || !this.viewport || this.realCount === 0) return;

        if (this.realCount > 1) {
          const clone = this.slides[0].cloneNode(true);
          clone.removeAttribute('data-review-slide');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-review-clone', '');
          this.track.appendChild(clone);
        }

        this.boundShowNext = this.showNext.bind(this);
        this.boundOnTransitionEnd = this.onTransitionEnd.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
        this.boundResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.track.addEventListener('transitionend', this.boundOnTransitionEnd);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
        window.addEventListener('resize', this.boundResize);

        this.measure();
        this.setPosition(false);

        if (this.dataset.autoplay === 'true' && this.realCount > 1 && !this.reduceMotion) {
          this.start();
        }
      }

      disconnectedCallback() {
        this.pause();
        this.unbindDrag();
        this.track?.removeEventListener('transitionend', this.boundOnTransitionEnd);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('mouseenter', this.pause);
        this.removeEventListener('mouseleave', this.resume);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.resume);
        window.removeEventListener('resize', this.boundResize);
        this.initialized = false;
      }

      measure() {
        if (!this.viewport) return;
        const styles = window.getComputedStyle(this.track);
        this.gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        this.slideWidth = this.viewport.offsetWidth;
        this.stride = this.slideWidth + this.gap;
      }

      onResize() {
        this.measure();
        this.setPosition(false);
      }

      getOffsetForIndex(index) {
        return index * this.stride;
      }

      setPosition(animate) {
        if (!this.viewport || !this.track) return;
        this.measure();
        this.dragOffset = 0;
        this.classList.toggle('is-animating', Boolean(animate) && !this.reduceMotion);
        this.track.style.transform = `translateX(-${this.getOffsetForIndex(this.index)}px)`;
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.index % this.realCount ? 'false' : 'true');
        });
      }

      start() {
        this.pause();
        this.timer = window.setInterval(this.boundShowNext, this.intervalMs);
      }

      pause() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      resume() {
        if (this.dataset.autoplay !== 'true' || this.realCount < 2 || this.reduceMotion) return;
        if (this.isDragging) return;
        if (!this.timer) this.start();
      }

      showNext() {
        if (this.realCount < 2 || this.isDragging) return;
        this.index += 1;
        this.setPosition(true);
      }

      onTransitionEnd(event) {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        if (this.index < this.realCount) return;
        this.index = 0;
        this.setPosition(false);
      }

      onPointerDown(event) {
        if (this.realCount < 2) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        this.isDragging = true;
        this.dragMoved = false;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.dragOffset = 0;
        this.pointerId = event.pointerId;
        this.pause();
        this.classList.add('is-dragging');
        this.classList.remove('is-animating');

        this.viewport.setPointerCapture?.(event.pointerId);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.isDragging || event.pointerId !== this.pointerId) return;

        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;

        if (!this.dragMoved) {
          if (Math.abs(deltaX) < 4 && Math.abs(deltaY) < 4) return;
          if (Math.abs(deltaY) > Math.abs(deltaX)) {
            this.cancelDrag();
            return;
          }
          this.dragMoved = true;
        }

        event.preventDefault();
        this.dragOffset = deltaX;
        const base = this.getOffsetForIndex(this.index);
        this.track.style.transform = `translateX(${-base + this.dragOffset}px)`;
      }

      onPointerUp(event) {
        if (!this.isDragging || event.pointerId !== this.pointerId) return;

        const deltaX = this.dragOffset;
        const threshold = Math.min(56, this.slideWidth * 0.18);
        let nextIndex = this.index;

        if (this.dragMoved) {
          if (deltaX <= -threshold) nextIndex = this.index + 1;
          else if (deltaX >= threshold) nextIndex = this.index - 1;
        }

        this.unbindDrag();
        this.isDragging = false;
        this.classList.remove('is-dragging');

        if (nextIndex < 0) nextIndex = 0;
        if (nextIndex > this.realCount) nextIndex = this.realCount;

        this.index = nextIndex;
        this.setPosition(true);

        if (this.index >= this.realCount) {
          window.setTimeout(() => {
            if (this.index >= this.realCount) {
              this.index = 0;
              this.setPosition(false);
            }
            this.resume();
          }, this.reduceMotion ? 0 : 560);
        } else {
          this.resume();
        }
      }

      cancelDrag() {
        this.unbindDrag();
        this.isDragging = false;
        this.classList.remove('is-dragging');
        this.setPosition(false);
        this.resume();
      }

      unbindDrag() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        if (this.pointerId != null) {
          try {
            this.viewport?.releasePointerCapture?.(this.pointerId);
          } catch (error) {
            // Ignore release errors when capture was never set.
          }
          this.pointerId = null;
        }
      }
    }

    customElements.define('review-quotes-slider', ReviewQuotesSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-trust-videos"] && !Shopify.designMode) return;
  try {
    (() => {
    const playMuted = (video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.controls = false;
      video.loop = true;
      video.playsInline = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const bind = (video) => {
      if (video.dataset.trustBound === 'true') return;
      video.dataset.trustBound = 'true';
      video.muted = true;
      video.volume = 0;
      video.setAttribute('muted', '');
      video.loop = true;
      video.playsInline = true;
      video.controls = false;

      const tryPlay = () => playMuted(video);
      if (video.readyState >= 2) tryPlay();
      video.addEventListener('canplay', tryPlay);
      video.addEventListener('loadeddata', tryPlay);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) tryPlay();
              else video.pause();
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(video);
      } else {
        tryPlay();
      }
    };

    const init = () => {
      document.querySelectorAll('[data-trust-video]').forEach(bind);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
